export const breakpoints = {
  large: 1320,
  medium: 1024,
  small: 768,
  smallest: 480
}

function mediaCheck(size, func = 'max') {
  let offset = 0
  if (func === 'min') {
    offset = 1
  }
  return window.matchMedia(`(${func}-width: ${size + offset}px)`)
}

function matchResult(match) {
  return {
    matches: match.matches,
    subcribe: (callback) => {
      if (match.addEventListener) {
        match.addEventListener('change', (event) => {
          callback(event.matches)
        })
      } else {
        match.addListener(() => {
          callback(match.matches)
        })
      }
    }
  }
}

function matchLarge(func = 'max') {
  return matchResult(mediaCheck(breakpoints.large, func))
}
function matchMedium(func = 'max') {
  return matchResult(mediaCheck(breakpoints.medium, func))
}
function matchSmall(func = 'max') {
  return matchResult(mediaCheck(breakpoints.small, func))
}
function matchSmallest(func = 'max') {
  return matchResult(mediaCheck(breakpoints.smallest, func))
}

export { matchLarge, matchMedium, matchSmall, matchSmallest }
